import { render, staticRenderFns } from "./IconTitle.vue?vue&type=template&id=94322524&scoped=true"
import script from "./IconTitle.vue?vue&type=script&lang=js"
export * from "./IconTitle.vue?vue&type=script&lang=js"
import style0 from "./IconTitle.vue?vue&type=style&index=0&id=94322524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94322524",
  null
  
)

export default component.exports